import {
  Box,
  Drawer,
  List,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
} from '@mui/material';
import { drawerWidth } from '../PageBase/PageBase';

export const CustomDrawer = styled(Drawer)(({ theme, open }) => ({
  backgroundColor: theme.palette.background.secondary,
  flexShrink: 0,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: 98,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  '& .MuiDrawer-paper': {
    width: 98,
    boxSizing: 'border-box',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.secondary,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  ...(open && {
    width: drawerWidth,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.secondary,
    color: theme.palette.primary.main,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      boxSizing: 'border-box',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.secondary,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  }),
}));

export const LogoWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  paddingTop: theme.spacing(12),
  paddingBottom: theme.spacing(12),
  justifyContent: 'center',
}));

interface ICustomListItemText {
  isActive?: boolean;
}

export const CustomListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<ICustomListItemText>(({ theme, isActive }) => ({
  color: isActive ? theme.palette.primary.main : theme.palette.text.tertiary,
}));

export const CustomList = styled(List)(({ theme }) => ({
  marginLeft: theme.spacing(8),
}));

export const CustomListItemIcon = styled(ListItemIcon)({
  minWidth: '57px',
});

export const CustomListLast = styled(List)(({ theme }) => ({
  marginTop: theme.spacing(5),
  marginLeft: theme.spacing(8),
  borderTop: `1px solid ${theme.palette.border.secondary}`,
}));

interface ILastWrapper {
  open: boolean;
}

export const LastWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<ILastWrapper>(({ theme, open }) => ({
  position: 'absolute',
  bottom: '5px',
  width: open ? '215px' : '80px',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

export const AppVersionText = styled(Typography)<{ open: boolean }>(
  ({ theme, open }) => ({
    color: theme.palette.primary.main,
    width: '100%',
    marginLeft: theme.spacing(10),
    visibility: open ? 'visible' : 'hidden',
  }),
);
